import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Input from 'Components/Input';
import Select from 'Components/Select';
import { Button } from 'Components/Button';
import { convertDataForSelect } from 'Utils/converters';
import validateContactUs from './validateContactUs';
import { errorMap } from 'Components/Input/errorMap';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';
import Textarea from 'Components/Textarea';
import {
  getCategories,
  getSubCategories,
  postContactUsForm,
  loginWithRefreshToken,
} from 'Store/actions';
import Modal from 'Components/Modal';
import Message from 'Components/Modal/Message';
import { getUrlParameter } from 'Utils/getUrlParameter';
import { isWebviewRenderType } from 'Utils/webviewMode';
import { customerServiceNumber } from 'Utils/getCustomerServicePhone';

const formFields = {
  firstName: '',
  lastName: '',
  email: '',
  categoryId: '',
  subCategoryId: '',
  contactUsContent: '',
  message: ''
};

class ContactUs extends Component {
  static propTypes = {
    getCategories: PropTypes.func,
    categories: PropTypes.object,
    getSubCategories: PropTypes.func,
    subCategories: PropTypes.object,
    postContactUsForm: PropTypes.func,
    auth: PropTypes.object,
    loginWithRefreshToken: PropTypes.func,
    postData: PropTypes.object,
    history: PropTypes.object,
    userInfo: PropTypes.object,
    location: PropTypes.object,
    icon: PropTypes.shape({
      name: PropTypes.string,
      onClick: PropTypes.func
    }),
  };

  constructor (props) {
    super(props);

    this.state = {
      ...formFields,
      validationErrors: {
        ...formFields
      },
      isLoading: false,
      fillInputsFromService: true,
      isLogin: false,
      activeModal: null,
      modalContent: null,
      modalTitle: null,
      modalIcon: null,
      modalType: null,
      isWebview: false
    };
  }

  async componentDidMount () {
    const { isAuthenticated, data } = this.props.auth;

    this.props.getCategories();

    this.setState({
      isWebview: isWebviewRenderType()
    });

    if (getUrlParameter('refreshToken')) {
      await this.props.loginWithRefreshToken(getUrlParameter('refreshToken'));
    }

    if (isAuthenticated) {
      this.setState({
        email: data?.email ?? '',
        isInputsDisabled: true,
        isEmailInputsDisabled: !!data?.email
      });
      this.fillInputs();
    }
  }

  async componentDidUpdate (prevProps) {
    let { isAuthenticated, data } = this.props.auth;

    if (prevProps.auth.isAuthenticated !== isAuthenticated) {
      if (isAuthenticated) {
        this.setState({
          email: data?.email ?? '',
          isInputsDisabled: true,
          isEmailInputsDisabled: !!data?.email
        });
        this.fillInputs();
      }
    }

    if (prevProps.postData !== this.props.postData) {
      this.modalTypeHandler();
    }
  }

  fillInputs () {
    const { name, surName } = this.props.auth.data;
    this.setState({
      firstName: name,
      lastName: surName
    });
  }

  clearFormInputs = () => {
    if (this.props.auth.isAuthenticated) {
      this.setState({
        categoryId: '',
        subCategoryId: '',
        contactUsContent: ''
      });
    } else {
      this.setState({
        firstName: '',
        lastName: '',
        email: '',
        categoryId: '',
        subCategoryId: '',
        contactUsContent: ''
      });
    }
  };

  modalTypeHandler = () => {
    const { postData } = this.props;

    if (postData && postData.data && postData.data.caseId) {
      this.setState({
        activeModal: 'messageModal',
        modalContent:
          'Sistemimizde Kayıtlı olan e-posta adresine talebinle ilgili en kısa sürede dönüş yapacağız',
        modalTitle: 'Mesajınız bize ulaştı',
        modalIcon: 'svgLike',
        modalType: 'success'
      });

      this.clearFormInputs();
    }

    if (postData && postData.error && postData.error.message) {
      this.setState({
        activeModal: 'messageModal',
        modalContent: `Teknik bir sorundan dolayı mesajın gönderilemedi. Dilersen Müşteri Hizmetlerimizi ${customerServiceNumber} arayabilirsin`,
        modalTitle: 'Mesajın gönderilemedi.',
        modalIcon: 'svgAlertTriangle',
        modalType: 'error'
      });
    }
  };

  closeModal = () => {
    this.setState({
      activeModal: null
    });
  };

  onChange = e => {
    let { id, value, tagName, options, selectedIndex } = e.target;

    this.setState({
      [id]: value,
      validationErrors: {
        ...this.state.validationErrors,
        [id]: ''
      }
    });

    if (tagName === 'SELECT') {
      const selectedText = options[selectedIndex].text;

      this.setState({
        [id + 'Text']: selectedText
      });
    }

    if (id === 'categoryId') {
      this.props.getSubCategories(value);
    }
  };

  onBlur = e => {
    let { id, value } = e.target;
    const validator = validateContactUs({
      ...this.state,
      [id]: value
    });

    if (!validator.isValid) {
      this.setState({
        validationErrors: {
          ...this.state.validationErrors,
          [id]: validator.errors[id]
        }
      });
    }
  };

  onSubmit = e => {
    e.preventDefault();

    let contactUsForm;
    const { auth } = this.props;
    const validator = validateContactUs(this.state);

    if (validator.isValid === true) {
      let variable = auth && auth.isAuthenticated ? 'channel' : 'channelId';

      contactUsForm = {
        [variable]: 'MOBIL_WEB',
        email: this.state.email,
        fullName: this.state.firstName + ' ' + this.state.lastName,
        // eslint-disable-next-line no-useless-escape
        message: this.state.contactUsContent.replace(/[`~!#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi, ''),
        subCategoryId: this.state.subCategoryId
      };

      this.props.postContactUsForm(contactUsForm);
    }
  };

  getInputError = fieldName => {
    const { validationErrors, fieldMessage } = this.state;

    return validationErrors[fieldName] === 'api'
      ? fieldMessage
      : errorMap[validationErrors[fieldName]];
  };

  render () {
    const {
      firstName,
      lastName,
      email,
      categoryId,
      categoryIdText,
      subCategoryId,
      subCategoryIdText,
      contactUsContent,
      isWebview
    } = this.state;
    const { categories, subCategories } = this.props;
    const categoryOptions = categories && categories.data;
    const subCategoryOptions = subCategories && subCategories.data;
    const isButtonDisabled = !(
      firstName
      && lastName
      && email
      && categoryId
      && subCategoryId
      && contactUsContent
    );

    const modalButtonConfig = isWebview ? (
      {
        primary: {
          label: 'Tamam',
          onClick: this.closeModal
        }
      }
    ) : (
      {
        primary: {
          label: 'ANA SAYFAYA GİT',
          onClick: () => this.props.history.push('/')
        }
      }
    );

    return (
      <>
        { !isWebview && (
          <HeaderSimplePage
            color="green"
            title="Bize Yazın"
            callCustomerService
            icon={ { name: 'svgCallCustomerService' } }
          />
        ) }

        <div className="page page--contact-us">
          <div className="contact-us__container">
            <form className="form" onSubmit={ this.onSubmit }>
              <div className="form__row">
                <div className="form__col form__col--50">
                  <Input
                    name="Ad"
                    id="firstName"
                    value={ firstName }
                    onChange={ this.onChange }
                    clearInput={ this.clearInput }
                    validateOnBlur
                    onBlur={ this.onBlur }
                    errorMessage={ this.getInputError('firstName') }
                    disabled={ this.state.isInputsDisabled }
                  />
                </div>
                <div className="form__col form__col--50">
                  <Input
                    name="Soyad"
                    id="lastName"
                    value={ lastName }
                    onChange={ this.onChange }
                    clearInput={ this.clearInput }
                    validateOnBlur
                    onBlur={ this.onBlur }
                    errorMessage={ this.getInputError('lastName') }
                    disabled={ this.state.isInputsDisabled }
                  />
                </div>
              </div>

              <div className="form__row">
                <Input
                  name="E-Posta Adresi"
                  id="email"
                  type="email"
                  value={ email }
                  onChange={ this.onChange }
                  clearInput={ this.clearInput }
                  onBlur={ this.onBlur }
                  validateOnBlur
                  errorMessage={ this.getInputError('email') }
                  disabled={ this.state.isEmailInputsDisabled }
                />
              </div>

              <div className="form__row">
                <Select
                  name="Kategori"
                  id="categoryId"
                  value={ categoryId }
                  text={ categoryIdText }
                  options={ convertDataForSelect(categoryOptions, 'id', 'name') }
                  onChange={ this.onChange }
                  onBlur={ this.onBlur }
                  validateOnBlur
                  required
                />
              </div>

              <div className="form__row">
                <Select
                  name="Konu"
                  id="subCategoryId"
                  value={ subCategoryId }
                  text={ subCategoryIdText }
                  options={ convertDataForSelect(subCategoryOptions, 'id', 'name') }
                  onChange={ this.onChange }
                  onBlur={ this.onBlur }
                  isDisabled={ !this.state.categoryId }
                  validateOnBlur
                  required
                />
              </div>

              <div className="form__row">
                <Textarea
                  id="contactUsContent"
                  value={ contactUsContent }
                  validateOnBlur
                  className="input--textarea"
                  placeholder="Bilyoner.com ile ilgili her türlü soru, öneri, şikayet ya da memnuniyetini bize ilet."
                  onBlur={ this.onBlur }
                  onChange={ this.onChange }
                  required
                />
              </div>

              <div className="form_row margin-top-10">
                <Button
                  title={ 'GÖNDER' }
                  disabled={ isButtonDisabled }
                  className="btn btn--primary btn--block"
                  type='submit'
                >
                  GÖNDER
                </Button>
              </div>
            </form>
          </div>
          { this.state.activeModal && (
            <Modal
              type={ this.state.modalType }
              iconName={ this.state.modalIcon }
              title={ this.state.modalTitle }
              onClose={ () => this.closeModal() }
            >
              <Message
                hasIcon={ false }
                type=""
                buttonConfig={ modalButtonConfig }
              >
                { this.state.modalContent }
              </Message>
            </Modal>
          ) }
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.contactUs.categories,
  subCategories: state.contactUs.subCategories,
  postData: state.contactUs.postContactUsForm,
  auth: state.auth
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    {
      getCategories,
      getSubCategories,
      postContactUsForm,
      loginWithRefreshToken,
    }
  )
)(ContactUs);
